import React from 'react';

export enum ExpandableDrawerDirection {
  UP = 'UP',
  DOWN = 'DOWN',
}

export interface ExpandableDrawerProps {
  expandedContent: React.ReactNode;
  expandDirection: ExpandableDrawerDirection;
  stickToBottom: boolean;
  headerHeight: number;
  headerLeftContent: React.ReactNode;
  onExpand?: () => void;
  onClose?: () => void;
}

export interface DrawerTransitionProps {
  isExpanded: boolean;
  wasExpanded: boolean;
  expandedContent: React.ReactNode;
  expandDirection: ExpandableDrawerDirection;
}
